import { RouterModule } from "@angular/router";
import { ConnectureComponent } from "../connecture/connecture.component";
import { ProviderSearch } from "../providers/providerSearch.component";

const routes = [
    { path: "", component: ProviderSearch }
    , { path: 'connecture', component: ConnectureComponent }
]

const router = RouterModule.forRoot(routes, {
    useHash: false, anchorScrolling: 'enabled'
});

export default router;